<template>
    <ul class="unfinished">
        <van-list
                v-model="loading"
                :finished="finished"
                :offset="10"
                finished-text="没有更多了"
                @load="onLoad">
            <li v-for="(item,index) in listData" :key="index" @click="toInfo(item.id)">
                <div class="statusBox">
                    <div>状态：<span>{{stateInfo(item.status)}}</span></div>
                    <div>备注码：{{item.remark}}</div>
                </div>
                <div class="top">
                    <div>价格：<span>{{item.price}} RMB</span></div>
                    <div>类型：<span>{{item.type === 1? "购买" : "出售"}}</span></div>
                </div>
                <div class="center">
                    <div>数量：<span>{{item.num}} {{item.coin.toLocaleUpperCase()}}</span></div>
                    <div>总额：<span>{{item.num * item.price}}</span></div>
                </div>
                <div class="bottom">
                    <div>商家：<span>{{item.uname}}</span></div>
                    <div class="imgWrap">
                        支付方式：
                        <img :src="item.weixin >0 ? wx_active : wx" alt="">
                        <img :src="item.alipay >0 ? ali_active : ali" alt="">
                        <img :src="item.bank >0 ? yl_active : yl" alt="">
                    </div>
                </div>
            </li>
        </van-list>
    </ul>
</template>

<script>
    // 微信图片
    import wx from "@/assets/img/c2c/wx@3x.png"
    import wx_active from "@/assets/img/c2c/wx_active@3x.png"
    // 支付宝图片
    import ali from "@/assets/img/c2c/ali@3x.png"
    import ali_active from "@/assets/img/c2c/ali_active@3x.png"
    // 银联图片
    import yl from "@/assets/img/c2c/yl@3x.png"
    import yl_active from "@/assets/img/c2c/yl_active@3x.png"

    export default {
        name: "unfinished",
        data() {
            return {
                wx,
                wx_active,
                ali,
                ali_active,
                yl,
                yl_active,
                page: 0,
                total: null,
                loading: false,
                finished: false,
                listData: []
            }
        },
        methods: {
            getData() {
                this.page++;
                this.ajax.post('appapi/c2c/norder', {page: this.page,}).then((res) => {
                    if (res.data.code === 1) {
                        this.listData.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.listData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                })
            },
            onLoad() {
                setTimeout(() => {
                    this.getData();
                }, 500);
            },
            stateInfo(state) {
                switch (state) {
                    case 1:
                        return "未付款";
                    case 2:
                        return "待确认";
                    case 3:
                        return "完成";
                    case -1:
                        return "撤销";
                    case 4:
                        return "申诉中";
                }
            },
            toInfo(id) {
                this.$router.push({path: "/c2cOrder", query: {id: id}});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .unfinished {
        margin-top: 44px;
        padding: 0 39px 100px 34px;

        li {
            padding: 21px 38px 28px;
            background: #fff;
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.5);
            border-radius: 20px;
            margin-bottom: 23px;

            .statusBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 48px;

                div {
                    font-size: 24px;
                    font-weight: bold;
                    color: rgba(119, 119, 119, 1);
                    line-height: 20px;

                    span {
                        color: #FF932A;
                    }
                }
            }

            .top, .center, .bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;

                div {
                    font-size: 24px;
                    font-weight: bold;
                    color: rgba(119, 119, 119, 1);
                    line-height: 20px;

                    span {
                        color: #1fc26d;
                    }
                }

                .imgWrap {
                    display: flex;
                    align-items: center;

                    img {
                        width: 44px;
                        margin-right: 20px;

                        &:nth-child(1) {
                            width: 38px;
                            margin-right: 24px;
                        }

                        &:nth-child(2) {
                            width: 35px;
                            margin-right: 33px;
                        }

                        &:nth-child(3) {
                            width: 44px;
                            margin-right: 0;
                        }
                    }
                }
            }

            .bottom {
                margin-bottom: 0;
            }
        }
    }
</style>
